export default function CTA() {
  return (
    <section className="relative w-full px-4 md:px-6 py-20 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cozy%20night%20scene%20with%20soft%20golden%20glow%20from%20windows%2C%20peaceful%20city%20at%20night%2C%20comforting%20atmosphere%2C%20gentle%20bokeh%20lights%2C%20hopeful%20and%20inviting%20mood%2C%20abstract%20night%20photography%20with%20warm%20tones&width=1800&height=600&seq=cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
          凌晨需要帮助？我们一直在
        </h2>
        <p className="text-background-200 text-sm md:text-base mb-8 max-w-xl mx-auto leading-relaxed">
          无论几点，无论什么事，凌晨不打烊的专业团队都在线守候。
          深夜下单、凌晨咨询、随时响应——你从不孤单。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="/categories"
            className="px-8 py-3.5 bg-primary-500 text-white rounded-full text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-all cursor-pointer shadow-[0_0_40px_rgba(255,140,50,0.4)]"
          >
            探索全部服务
          </a>
          <a
            href="/about#contact"
            className="px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white border border-white/30 rounded-full text-base font-medium whitespace-nowrap hover:bg-white/20 transition-all cursor-pointer"
          >
            联系在线客服
          </a>
        </div>
      </div>
    </section>
  );
}